import { ComponentStyleConfig } from '@chakra-ui/react';

const defaultButtonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'auto',
  padding: '7px 18px',
  textAlign: 'center',
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '100%',
  color: 'button.defaultText',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  userSelect: 'none',
  outline: 'none',
  boxShadow: 'none',
  textDecoration: 'none',
};

const buttonsWithShadowAnimation = {
  transition: 'box-shadow 0.3s, transform 0.3s',
  _focus: {
    boxShadow: 'buttonShadow',
    transform: 'translateY(0)',
  },
  _active: {
    boxShadow: 'none',
    transform: 'translateY(4px)',
  },
  _disabled: {
    outline: 'none',
    boxShadow: 'buttonShadow',
    _hover: {
      boxShadow: 'buttonShadow',
      transform: 'translateY(0)',
    },
  },
};

const Button: ComponentStyleConfig = {
  baseStyle: {
    outline: 'none',
    _hover: {
      outline: 'none',
      boxShadow: 'none',
    },
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
    _active: {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  sizes: {
    sm: {
      fontSize: '17px',
      px: '12px',
      py: '8px',
    },
    md: {
      fontSize: '17px',
      px: '27px',
      py: '8px',
    },
  },
  variants: {
    primary: {
      ...defaultButtonStyles,
      background: 'button.primary.bg',
      boxShadow: 'buttonShadow',
      borderRadius: '6px',
      color: 'button.primary.text',
      _disabled: {
        color: 'button.primary.disabledText',
      },
      _hover: {
        boxShadow: 'none',
        transform: 'translateY(4px)',
        textDecoration: 'none',
        _disabled: {
          background: 'button.primary.disabledBg',
          outline: 'none',
          boxShadow: 'buttonShadow',
        },
      },
    },
    secondary: {
      ...defaultButtonStyles,
      ...buttonsWithShadowAnimation,
      background: 'button.secondary.disabledBg',
      boxShadow: 'buttonShadow',
      borderRadius: '6px',
      border: '2px solid',
      borderColor: 'button.secondary.border',
      color: 'button.secondary.text',
      _hover: {
        boxShadow: 'none',
        transform: 'translateY(4px)',
        textDecoration: 'none',
        _disabled: {
          background: 'button.secondary.disabledBg',
          outline: 'none',
          boxShadow: 'buttonShadow',
        },
      },
      ...buttonsWithShadowAnimation,
    },
    ghost: {
      ...defaultButtonStyles,
      _hover: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
        textDecoration: 'none',
      },
      _focus: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
      },
      _active: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
      },
    },
    outline: {
      ...defaultButtonStyles,
      border: '2px solid',
      borderColor: 'button.outline.border',
      _hover: {
        background: 'button.primary.bg',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'ghost',
  },
};

export default Button;
